import {ChangeEvent, useContext, useEffect, useState} from "react";
import {Button} from "react-bootstrap";
import {AppContext} from "../../../../appContext/AppContext";
import CustomIconButton from "../../../../component/custom-icon-button/CustomIconButton";
import InputSearch from "../../../../component/InputSearch";
import {TableCustomHeader} from "../../../../component/table/components/TableCustomHeader";
import {TablePagination} from "../../../../component/table/components/TablePagination";
import {TableCustom} from "../../../../component/table/table-custom/TableCustom";
import TextField from "../../../../component/TextField";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  KEY,
  SELECTION_MODE,
} from "../../../../utils/Constant";
import {handlePagesChange, handleRowsPerPageChange, rowsForPage} from "../../../../utils/PageUtils";
import {DanhSachPhieuColumns} from "../constants/ColumnsKeHoach";
import "../XayDungKeHoach.scss";
import DialogPhieuKeHoach from "./DialogPhieuKeHoach";
import WfStatusSummary from "../../../../workflows/components/WfStatusSummary";
import {deletePhieuKeHoach, searchPhieuKeHoach} from "../services/services";
import {ConfirmDialog} from "../../../../component/ConfirmDialog";
import {toast} from "react-toastify";
import {XayDungKeHoachContext} from "../HoTroKyThuatChuyenMon";
import {getSummaryStatusWf} from "../../../../workflows/services/WfWorkflowsService";
import {formatDateFromDTOCustom, formatDateToDTOCustom} from "../../../../utils/FormatUtils";
import {
  STATUS_CODE,
  TYPE_KB_CB,
  TYPE_KE_HOACH, WMS_STATUS
} from "../constants/constansKeHoach";
import {TypeKeHoach} from "../models/KeHoachModel";
import DialogPhieuNghiemThu from "./DialogPhieuNghiemThu";
import DialogBienBanNhiemVu from "./DialogBienBanNhiemVu";
import DialogBaoCaoKetQua from "./DialogBaoCaoKetQua";

interface Props {
  warehouseId: any;
  className?: any;
}

export const FormKeHoach = (props: Props) => {
  const {warehouseId, className} = props;
  const [typeKeHoach, setTypeKeHoach] = useState<TypeKeHoach>(TYPE_KE_HOACH[0]);
  const [dsPhieuKeHoach, setDsPhieuKeHoach] = useState<any[]>([]);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const {setDsKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [openDialogConfirmDelete, setOpenDialogConfirmDelete] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const {setIsLoading} = useContext(AppContext);
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });

  // State để xác định dialog nào đang mở
  const [activeDialog, setActiveDialog] = useState<string | null>(null);

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const res = await deletePhieuKeHoach(WMS_STATUS.build_plan, itemSelected.id);
      if (CODE.SUCCESS === res.status) {
        toast.success("Xóa phiếu thành công");
        handleCloseDialog();
      }
    } catch (error: any) {
      const message = error?.message || "Có lỗi xảy ra, vui lòng thử lại";
      toast.error(message)
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleCloseDialog = () => {
    setDsKeHoach([]);
    setDetailPhieuKeHoach({});
    setOpenDialogConfirmDelete(false);
    setOpenDialogThemMoi(false);
    setActiveDialog(null);
    setItemSelected({});
    setTimeout(() => {
      updatePageData();
    }, 500)
  };

  const handleOpenDialog = (item: any, isView: boolean = false) => {
    setItemSelected(item);
    setActiveDialog(null);
    setDetailPhieuKeHoach({...item, isView});

    const statusCode = item?.statusCode;

    switch (statusCode) {
      case STATUS_CODE.pending_deployment:
        // Mở DialogBienBanNhiemVu
        setActiveDialog('PHIEU_KE_HOACH');
        break;
      case STATUS_CODE.being_supported:
        // Mở DialogPhieuKeHoach
        setActiveDialog('BIEN_BAN_NHIEM_VU');
        break;
      case STATUS_CODE.pending_report:
        // Mở DialogBaoCaoKetQua
        setActiveDialog('BAO_CAO_KET_QUA');
        break;
      case STATUS_CODE.pending_acceptance:
        // Mở DialogPhieuNghiemThu
        setActiveDialog('NGHIEM_THU');
        break;
      default:
        // Mặc định mở DialogPhieuKeHoach
        setActiveDialog('PHIEU_KE_HOACH');
        break;
    }

    setOpenDialogThemMoi(true);
  };

  const updatePageData = async () => {
    try {
      setIsLoading(true);
      const {data} = await searchPhieuKeHoach({
        ...searchData,
        keyword: searchData?.keyword?.trim() || null,
        doCreationFromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate),
        doCreationToDate: formatDateToDTOCustom(searchData?.doCreationToDate),
        type: 2,
        pageSize: rowsPerPage,
        pageIndex: page,
        trackerCode: typeKeHoach.trackerCode
      });
      const resSummary = await getSummaryStatusWf(
        typeKeHoach.trackerCode,
        {
          fromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate) || null,
          toDate: formatDateToDTOCustom(searchData?.doCreationToDate) || null,
        }
      );

      if (CODE.SUCCESS === resSummary.data?.code) {
        setSummaryStatus(resSummary.data.data);
      }
      if (CODE.SUCCESS === data.code) {
        setDsPhieuKeHoach(data?.data?.content || []);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data?.data?.pageable?.totalElements,
        })
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updatePageData();
  }, [rowsPerPage, page, warehouseId, typeKeHoach.code]);

  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }

  const columnsActions = {
    Header: (props: any) => (
      <TableCustomHeader<any>
        tableProps={props}
        title={"Thao tác"}
        className='text-center text-light spaces w-80px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <div className="d-flex justify-content-center gap-3">
        {props.cell.row.original?.statusCode !== STATUS_CODE.approved_done && <CustomIconButton
          variant="edit"
          onClick={() => {
            handleOpenDialog(props.cell.row.original, false);
          }}
        >
          <i className="bi bi-pencil-square text-navy"></i>
        </CustomIconButton>}
        <CustomIconButton
          variant="view"
          onClick={() => {
            handleOpenDialog(props.cell.row.original, true);
          }}
        >
          <i className="bi bi-eye"></i>
        </CustomIconButton>
      </div>
    )
  };

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 ">
              <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0 px-10 min-w-180">
                Danh sách hỗ trợ kỹ thuật
              </h4>
            </div>
            <div className="d-flex  mt-1 flex-column spaces width-100 ">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Từ ngày"
                      name="doCreationFromDate"
                      type="date"
                      value={searchData?.doCreationFromDate || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đến ngày"
                      name="doCreationToDate"
                      type="date"
                      className="flex"
                      value={searchData?.doCreationToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm theo mã phiếu"
                      handleChange={handleChangeSearchData}
                      handleSearch={() => handlerSearchKeyWorld()}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4 radius-3"
                    />
                  </div>
                </div>
                <div className="spaces bg-white mb-0">
                  <TableCustom<any>
                    className={`spaces ${className ? className : "h-bang-ds-phieu"}`}
                    data={dsPhieuKeHoach}
                    columns={DanhSachPhieuColumns}
                    columnsActions={columnsActions}
                    verticalScroll={true}
                    selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={Number(configTable.totalPages)}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={2} />}
                    customComponentClassName={'spaces min-w-1000'}
                    className="border border-0"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Render dialog dựa theo activeDialog */}
          {openDialogThemMoi && activeDialog === 'PHIEU_KE_HOACH' && (
            <DialogPhieuKeHoach
              warehouseId={warehouseId}
              type={typeKeHoach}
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={itemSelected}
              setInitialValues={setItemSelected}
            />
          )}

          {openDialogThemMoi && activeDialog === 'BIEN_BAN_NHIEM_VU' && (
            <DialogBienBanNhiemVu
              warehouseId={warehouseId}
              type={typeKeHoach}
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={itemSelected}
              setInitialValues={setItemSelected}
            />
          )}

          {openDialogThemMoi && activeDialog === 'BAO_CAO_KET_QUA' && (
            <DialogBaoCaoKetQua
              type={TYPE_KB_CB.BAO_CAO_KET_QUA}
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={itemSelected}
              setInitialValues={setItemSelected}
            />
          )}

          {openDialogThemMoi && activeDialog === 'NGHIEM_THU' && (
            <DialogPhieuNghiemThu
              type={TYPE_KB_CB.NGHIEM_THU}
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={itemSelected}
              setInitialValues={setItemSelected}
            />
          )}

          {openDialogConfirmDelete && (
            <ConfirmDialog
              show={openDialogConfirmDelete}
              onCloseClick={handleCloseDialog}
              onYesClick={handleDelete}
              title="Xóa kế hoạch"
              message={`Bạn chắc chắn muốn xóa phiếu: ${itemSelected.code} ?`}
              yes="Xóa"
              close="Hủy"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default FormKeHoach;